import React, { useState } from 'react'
import { LucideIcon } from 'components/shared'
import { LucideCopy } from 'lucide-react'

interface GuestIdCopyProps {
    guestId: string | number
}

export default function GuestIdCopy({ guestId }: GuestIdCopyProps) {
    const [isCopied, setIsCopied] = useState(false)

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(String(guestId))
            setIsCopied(true)
            setTimeout(() => {
                setIsCopied(false)
            }, 1500)
        } catch (err) {}
    }

    return (
        <div
            className="group relative flex flex-row items-center gap-2 cursor-pointer rounded-md px-1 border border-transparent transition-all duration-200 hover:bg-primary-950 hover:border-primary-800 hover:shadow-sm"
            onClick={handleCopy}
        >
            {/* 호버 툴팁 */}
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-1 py-0.5 bg-gray-800 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
                유저 식별번호 복사
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
            </div>

            <p className="break-words group-hover:text-primary-600 transition-colors">{guestId}</p>

            {isCopied ? (
                <LucideIcon
                    name="Check"
                    size={12}
                    className="w-[14px] text-green-500 transition-colors"
                />
            ) : (
                <LucideCopy className="w-[14px] group-hover:text-primary-500 transition-colors opacity-60 group-hover:opacity-100" />
            )}
        </div>
    )
}
